var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-file',{attrs:{"placeholder":_vm.placeHolderText || 'Select or Drop File Here...',"drop-placeholder":_vm.dropPlaceHolderText || 'Drop file here...'},on:{"change":_vm.loadTextFromFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }